import React, { useMemo } from 'react';
import { Navigate } from 'react-router-dom';
import { Box, Image } from '@chakra-ui/react';

import { LinkButton } from '../../../../common/components/LinkButton';
import { MainPageContent } from '../../../../common/components/MainPageContent';
import MainPageHeading from '../../../../common/components/MainPageHeading/MainPageHeading';
import { getIconPath } from '../../../../common/components/Navbar/Menu/utils/menuHelper';
import { Routes } from '../../../../config/routes';
import { useTranslations } from '../../../../contexts/LocalizationContext';
import { ScannedRelevosContextProvider } from '../../../../contexts/ScannedRelevosContext';
import { useRestaurantsData } from '../../../../services/restaurants';
import { ScannerMode } from '../../../RelevoAssignment/model/enums/scanner-mode.enum';
import { DepositScanner } from '../../common/components/DepositScanner/DepositScanner';
import DepositSumUp from '../../common/components/DepositSumUp/DepositSumUp';
import { DepositResultContextProvider } from '../../context/DepositResultContext/DepositResultContext';

export const ReturnDeposit = () => {
  const translations = useTranslations();
  const { restaurants, isDepositEnabled } = useRestaurantsData();
  const depositRestaurants = useMemo(
    () => restaurants.filter((restaurant) => restaurant.isDepositEnabled),
    [restaurants],
  );

  if (restaurants.length && !isDepositEnabled) {
    return <Navigate to={Routes.HOME_PATH} />;
  }

  return (
    <MainPageContent>
      <MainPageHeading>
        <LinkButton variant={'beigeSolid'} to={Routes.DEPOSIT_PATH} size="sm" top="-2px">
          <Image cursor="pointer" src={getIconPath('return-icon.svg')} mr="6px" />
          {translations('deposit_back_button')}
        </LinkButton>
        {translations('return_deposit_heading')}
      </MainPageHeading>
      {depositRestaurants.length ? (
        <DepositResultContextProvider>
          <ScannedRelevosContextProvider mode={ScannerMode.DEPOSIT_RETURN} locationId={depositRestaurants[0].id}>
            <Box>
              <DepositScanner restaurants={depositRestaurants} />
              <DepositSumUp />
            </Box>
          </ScannedRelevosContextProvider>
        </DepositResultContextProvider>
      ) : null}
    </MainPageContent>
  );
};
